<template>
	<div class="bar">
		<div class="bar_option">
			<!-- <div class="bar_option_box" @click="barfun(0)">
				<span v-if="lang==1">虚拟景区</span>
				<span v-if="lang==2">virtually</span>
				<span v-if="lang==3">仮想化</span>
				<span v-if="lang==4">가상</span>
				
			</div> -->
			<div class="bar_option_box" @click="barfun(1)">
				
				<span v-if="lang==1">菌文化</span>
				<span v-if="lang==2">Culture</span>
				<span v-if="lang==3">菌文化</span>
				<span v-if="lang==4">문화</span>
			</div>
			<div class="bar_option_box" @click="barfun(2)">
				
				<span v-if="lang==1">景区景点</span>
				<span v-if="lang==2">Scenery</span>
				<span v-if="lang==3">観光地</span>
				<span v-if="lang==4">관광지</span>
			</div>
			<div class="bar_option_box" @click="barfun(3)">
				
				<span v-if="lang==1">旅游服务</span>
				<span v-if="lang==2">Serves</span>
				<span v-if="lang==3">サービス</span>
				<span v-if="lang==4">서비스</span>
			</div>
			<div class="bar_option_box" @click="barfun(4)">
				
				<span v-if="lang==1">旅游指南</span>
				<span v-if="lang==2">Travel guide</span>
				<span v-if="lang==3">ガイドブック</span>
				<span v-if="lang==4">여행 안내서</span>
			</div>
			<!-- <div class="bar_option_box">
				
				<span v-if="lang==1">联系方式</span>
				<span v-if="lang==2">contact</span>
				<span v-if="lang==3">連絡先</span>
				<span v-if="lang==4">연락처</span>
			</div> -->
		</div>
		<div class="bar_phone">
			<div class="bar_phone_box">
				
				<span v-if="lang==1">景区地址：重庆市万盛经济技术开发区丛林镇 景区游客最大承载量：18000人</span>
				<span v-if="lang==2">Address: Jungle Town, Chongqing City The maximum carrying capacity of tourists in the scenic area: 18000 people</span>
				<span v-if="lang==3">観光地住所：重慶市萬盛経済技術開発区ジャングル鎮 観光地観光客の最大積載量：18000人</span>
				<span v-if="lang==4">관광지 주소: 충칭시 만성경제기술개발구 정글진 관광지 관광객 최대 수용량: 18000명</span>
			</div>
			<div class="bar_phone_box">
				
				<span v-if="lang==1">咨询电话：023-48264666</span>
				<span v-if="lang==2">seek：023-48264666</span>
				<span v-if="lang==3">コンサルティング：023-48264666</span>
				<span v-if="lang==4">컨설팅：023-48264666</span>
			</div>
			<div class="bar_phone_box">
				
				<span v-if="lang==1">救援电话：023-48331176</span>
				<span v-if="lang==2">Rescue：023-48331176</span>
				<span v-if="lang==3">救援電話：023-48331176</span>
				<span v-if="lang==4">구조 전화：023-48331176</span>
			</div>
			<div class="bar_phone_box">
				
				<span v-if="lang==1">投诉电话：023-48333082</span>
				<span v-if="lang==2">Complaints：023-48333082</span>
				<span v-if="lang==3">クレーム電話：023-48333082</span>
				<span v-if="lang==4">신고 전화：023-48333082</span>
			</div>
			<div class="bar_phone_box" @click="nuv()">
				<span v-if="lang==1">全国旅游监管服务平台：12345</span>
				<span v-if="lang==2">Regulatory platform：12345</span>
				<span v-if="lang==3">全国観光規制サービスプラットフォーム：12345</span>
				<span v-if="lang==4">전국 관광 감독 관리 서비스 플랫폼：12345</span>
			</div>
		</div>
		<div class="bar_wang"  @click="rescue()">
			
			<span v-if="lang==1">CopyRight © 2023 xibujungu All Rights Reserved.Design by:至上互动 <span @click.stop="ban()">渝ICP备2021007579号-2</span></span>
			<span v-if="lang==2">CopyRight © 2023 xibujungu All Rights Reserved.Design by:Riesun <span @click.stop="ban()">ICP:渝ICP备2021007579号-2</span></span>
			<span v-if="lang==3">CopyRight © 2023 xibujungu All Rights Reserved.Design by:上位インタラクション <span @click.stop="ban()">ICP:渝ICP备2021007579号-2</span></span>
			<span v-if="lang==4">CopyRight © 2023 xibujungu All Rights Reserved.Design by:최상의 상호 작용 <span @click.stop="ban()">ICP:渝ICP备2021007579号-2</span></span>
		</div>
		
		
		<!--  -->
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../static/home/riesun.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'bar',
		data() {
			return {
				lang:1,		//语言
				riesunfalg:false,
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 1
		},
		components: {
			
		},
		methods:{
			nuv(){
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			
			ban(){		//备案
				window.open('https://beian.miit.gov.cn/#/Integrated/index',"_blank");
			},
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
			
			barfun(e){
				if(e==1){
					if(this.$route.name == 'culture'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'culture',query:{nums:0}})
					}
				}
				if(e==2){
					if(this.$route.name == 'scenic'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'scenic',query:{nums:0}})
					}
				}
				if(e==3){
					if(this.$route.name == 'service'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'service',query:{nums:0}})
					}
				}
				if(e==4){
					if(this.$route.name == 'guide'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'guide',query:{nums:0}})
					}
				}
				
			}
			
		},
		
	}
</script>

<style scoped lang="less">
	//
	.bar{
		position: absolute;
		z-index: 10;
		bottom: 0;
		left: 0;
		width: 1920px;
		height: 109px;
		background-color: #fff;
		Box-shadow: 0px 0px 30px 0px #ededed;
	}
	.bar_option{
		margin-top: 24px;
		display: flex;
		justify-content: center;
	}
	.bar_option_box{
		height: 17px;
		line-height: 17px;
		font-size: 16px;
		color: #333333;
		padding: 0 6px;
		border-left: 1px solid #333333;
		
	}
		.bar_option_box:nth-child(1){
			height: 17px;
			line-height: 17px;
			font-size: 16px;
			color: #333333;
			padding: 0 6px;
			border-left: 1px solid transparent;
		}
	.bar_phone{
		margin-top: 8px;
		display: flex;
		justify-content: center;
	}
	.bar_phone_box{
		height: 17px;
		line-height: 17px;
		font-size: 16px;
		color: #333333;
		padding: 0 6px;
		border-left: 1px solid #333333;
	}
		.bar_phone_box:nth-child(1){
			height: 17px;
			line-height: 17px;
			font-size: 16px;
			color: #333333;
			padding: 0 6px;
			border-left: 1px solid transparent;
		}
	.bar_wang{
		font-size: 12px;
		color: #999999;
		margin-top: 8px;
		text-align: center;
	}
	
	//
	.riesun{
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>